import * as Styled from '../DocumentPreview.styles';
import * as StyledBox from './ContractorBox.styles';

export const ContractorBox = ({ title, children }) => {
  return (
    <Styled.VerticalLeftAligned>
      <StyledBox.Title>{title}</StyledBox.Title>
      {children}
    </Styled.VerticalLeftAligned>
  );
};
